// extracted by mini-css-extract-plugin
var _1 = "RestrictedContainerStyles-module__icon___FK0MV";
var _2 = "RestrictedContainerStyles-module__icon-container___hoIdV";
var _3 = "RestrictedContainerStyles-module__icon-container___hoIdV";
var _4 = "RestrictedContainerStyles-module__wrapper___Fbz49";
var _5 = "RestrictedContainerStyles-module__wrapper-center___vG_Cs";
var _6 = "RestrictedContainerStyles-module__wrapper-inner___aV8Tt";
var _7 = "RestrictedContainerStyles-module__wrapper-center___vG_Cs";
var _8 = "RestrictedContainerStyles-module__wrapper-inner___aV8Tt";
export { _1 as "icon", _2 as "icon-container", _3 as "iconContainer", _4 as "wrapper", _5 as "wrapper-center", _6 as "wrapper-inner", _7 as "wrapperCenter", _8 as "wrapperInner" }
